import React from 'react';
import FormNumberContainer from '../../../redux/containers/FormNumberContainer';
import ValidRanges from '../../../common/validation/ValidRanges';
import AddressFinder from './AddressFinder';
import './CaAddressDetails.scss';

const CaAddressDetails = props => (
  <div>
    <AddressFinder {...props} />
    <div className="row">
      <div className="col-sm-12 month-year-at-current-address">
        <FormNumberContainer
          name="creditAssessment.yearsAtCurrentAddress"
          label="Years at current address"
          className="auto-test-ca-years-at-address"
          min={ValidRanges.MIN_YEARS_AT_ADDRESS}
          max={ValidRanges.MAX_YEARS_AT_ADDRESS}
          maxLength={3}
          required
        />
      </div>
      <div className="col-sm-12 month-year-at-current-address">
        <FormNumberContainer
          name="creditAssessment.monthsAtCurrentAddress"
          label="Months at current address"
          className="auto-test-ca-months-at-address"
          min={ValidRanges.MIN_MONTHS_AT_ADDRESS}
          max={ValidRanges.MAX_MONTHS_AT_ADDRESS}
          maxLength={2}
        />
      </div>
    </div>
  </div>
);

export default CaAddressDetails;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/CreditAssessmentStep2/CaAddressDetails.js
 **/